import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import * as API from '../../Endpoints/Endpoints'; // Adjust as per your file structure

const UpdateCube = () => {
  const [cubeData, setCubeData] = useState({
    religion: '',
    theme: '',
    type: '',
    passiondimension: '',
    question: '',
    relatedSDG: '',
    agegroup: '',
    knownreligiouslead: '',
    briefdescriptionoflead: '',
  });

  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { cubeid } = useParams();

  useEffect(() => {
    fetchCubeData();
  }, [cubeid]);

  const fetchCubeData = () => {
    axios({
      url: API.GET_CUBE_BYID(cubeid),
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          setCubeData(res.data[0]);
        } else if (res.data) {
          setCubeData(res.data);
        } else {
          setError('No data found for this cube entry.');
        }
      })
      .catch((err) => {
        setError('Error fetching cube data: ' + err.message);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCubeData({ ...cubeData, [name]: value });
  };

  const updateCube = (e) => {
    e.preventDefault();
    console.log("Submitting data:", cubeData); 
  
    axios.put(API.PUT_CUBE_API(cubeid), cubeData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(() => {
      alert('Cube entry updated successfully.');
      navigate('/cubemaster');
    })
    .catch((err) => {
      console.error('Error updating cube entry:', err);
      alert('Error updating cube entry: ' + err.message);
    });
  };  

  const goBack = () => {
    navigate('/cubemaster'); // adjust to your listing page route
  };

  return (
    <div className="bg-[#B5B5B5] h-auto pb-20 pt-10">
      <div className="max-w-4xl mx-auto pt-10">
        <form onSubmit={updateCube} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

          {[
            'religion',
            'theme',
            'type',
            'passiondimension',
            'question',
            'relatedSDG',
            'agegroup',
            'knownreligiouslead',
            'briefdescriptionoflead'
          ].map((field) => (
            <div className="mb-4" key={field}>
              <label className="block text-gray-700 text-sm font-bold mb-2">
                {field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, ' $1')}
              </label>
              <input
                type="text"
                name={field}
                value={cubeData[field] || ''}
                onChange={handleInputChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              />
            </div>
          ))}

          <div className="flex items-center justify-between">
            <button
              type="submit"
              className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Update
            </button>
            <button
              type="button"
              onClick={goBack}
              className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Go Back
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateCube;
